import { Anchor, Box, Container, Flex, Group, Text, useComputedColorScheme, useMantineTheme } from '@mantine/core'
import { Link } from 'react-router-dom'

export function SiteFooter() {
  const theme = useMantineTheme()
  const computed = useComputedColorScheme('dark')
  const isDark = computed === 'dark'

  const colors = {
    background: isDark ? theme.colors.dark[9] : 'var(--sat-text)',
    border: isDark ? theme.colors.dark[4] : 'var(--sat-green)',
    text: isDark ? theme.colors.gray[4] : 'var(--sat-blush)',
  }

  const routeLinks = [
    { label: 'About', to: '/about' },
    { label: 'Contact', to: '/contact' },
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Terms', to: '/terms' },
  ]

  return (
    <Box
      component="footer"
      style={{
        background: colors.background,
        borderTop: `2px solid ${colors.border}`,
      }}
      py={32}
    >
      <Container size="lg">
        <Flex
          justify="space-between"
          align="center"
          direction={{ base: 'column', sm: 'row' }}
          gap="md"
        >
          <Text fw={700} fz="lg" c="var(--mantine-color-white)">
            SAT Tutor
          </Text>

          <Group gap="lg">
            {routeLinks.map(({ label, to }) => (
              <Anchor key={label} component={Link} to={to} fz="sm" c={colors.text} underline="hover">
                {label}
              </Anchor>
            ))}
          </Group>

          <Text fz="sm" c={colors.text}>
            &copy; 2026 SAT Tutor. All rights reserved.
          </Text>
        </Flex>
      </Container>
    </Box>
  )
}
